import { getClientInitials } from "../../settings/client/clientUtils";

const CampaignOriginCell = ({ name, city }) => {
  const displayName = name?.trim() || "—";
  const displayCity = city?.trim() || null;
  const initials = getClientInitials(displayName === "—" ? "" : displayName);

  return (
    <div className="flex items-center gap-2 min-w-0 w-full">
      <span
        className="campaign-origin-cell__logo shrink-0 font-semibold text-xs flex items-center justify-center"
        aria-hidden
      >
        {initials}
      </span>
      <div className="flex flex-col min-w-0 gap-0.5">
        <span
          className="text-sm font-extrabold text-[#222222] truncate leading-[22px]"
          title={displayName}
        >
          {displayName}
        </span>
        {displayCity ? (
          <span
            className="text-xs text-[#5e5e5e] truncate leading-[22px]"
            title={displayCity}
          >
            {displayCity}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default CampaignOriginCell;
